import React from "react";
import styles from "../../../pages/styles";

const InputField = ({ title, name, value, onChange, placeholder, dark = false }) => (
  <div className={`${dark ? styles.paragraphwhite : styles.paragraph} mb-2`}>
    {title}
    <input
      name={name}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      required
      className={`w-full text-base rounded-xl border-2 px-4 py-2 focus:outline-none ${
        dark 
          ? "bg-white/10 backdrop-blur-sm border-white/30 text-white placeholder-white/50 focus:border-orangeprimary" 
          : "border-pinkprimary focus:border-orangeprimary"
      }`}
    />
  </div>
);

export default InputField;
